const createRoomEvents = {
  action: "create-room",
  labels: {
    close: () => `close`,
    filter: (filterProp) => `filter:${filterProp}`,
    openFilter: (filterProp) => `open-filter:${filterProp}`,
    clearFilters: () => `clear-filters`,
    closeFilter: (filterProp) => `close-filter:${filterProp}`,
    showAll: (filterProp, value) =>
      value ? `show-all:${filterProp}:${value}` : `show-all:${filterProp}`,
    checkOption: (filterProp, value) => `check-option:${filterProp}:${value}`,
    uncheckOption: (filterProp, value) =>
      `uncheck-option:${filterProp}:${value}`,
    signInClick: () => `sign-in-click`,
    roomSelect: (sceneId) => `room-select:${sceneId}`,
  },
};

export default createRoomEvents;
